<footer class="bg-surface-darker border-t border-accent px-6 py-8 sm:px-8 lg:px-10 lg:py-0">
  <div
    class="mx-auto flex min-h-32 max-w-350 flex-col items-center justify-between gap-8 font-sans text-sm font-light leading-5 tracking-[0.005em] text-white sm:min-h-36 sm:flex-row sm:gap-10 lg:min-h-44 lg:gap-16"
  >
    <div class="flex items-center gap-4">
      <img
        ngSrc="assets/images/logo.png"
        alt="Spare Cores"
        width="454"
        height="211"
        class="h-6 w-auto"
      />
      <span>&copy; 2026 Spare Cores <span class="text-teal-500">|</span> All rights reserved.</span>
    </div>
    <div class="flex flex-wrap items-center justify-center gap-x-1 gap-y-1 sm:justify-end">
      <a
        [href]="privacyUrl"
        target="_blank"
        rel="noopener"
        data-ph-capture-attribute-sc-event="url click"
        class="hover:text-accent transition-colors"
        >Privacy Policy</a
      >
      <span class="text-accent">|</span>
      <a
        [href]="termsUrl"
        target="_blank"
        rel="noopener"
        data-ph-capture-attribute-sc-event="url click"
        class="hover:text-accent transition-colors"
        >Terms of Service</a
      >
      <span class="text-accent">|</span>
      <a routerLink="/plans" class="hover:text-accent transition-colors">Plans and Pricing</a>
      <span class="text-accent">|</span>
      <a routerLink="/plans" fragment="common-questions" class="hover:text-accent transition-colors"
        >FAQ</a
      >
      <span class="text-accent">|</span>
      <a [href]="contactEmail" class="hover:text-accent transition-colors">Contact us</a>
    </div>
  </div>
</footer>
